/**
 * Background image assignments for different app sections.
 * All paths are relative to the public/ folder (served at root).
 * Swap these to your own images as desired.
 */

export const BACKGROUNDS = {
  // Workspace view levels
  room: "/assets/IMG_20210404_bark_HDR-min.jpg",
  desk: "/assets/IMG-20250110-charsits.jpg",
  notebook: "/assets/IMG-20250110-trusunshine.jpg",

  // Modals
  reader: "/assets/IMG_20221023_garden_01.jpg",
  editor: "/assets/IMG-20250110-choconfi.jpg",

  // Routes / pages
  help: "/assets/IMG-20250110-panstairs.jpg",
  dashboard: "/assets/IMG_20221023_garden_00.jpg",
  auth: "/assets/IMG-20250110-trubalcon.jpg",

  // Fallback
  default: "/assets/IMG_20210404_bark_HDR-min.jpg",
};

export default BACKGROUNDS;
